import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './App.css';

// Google Analytics & History
import ReactGA from 'react-ga4';

// Components
import { Footer, Header, Main, ScrollToTop } from './components';
import { notFoundMeta, pageMeta } from './data/pageMeta';
import { canonicalUrl } from './data/structuredData';

const setMeta = (selector, value) => document.querySelector(selector)?.setAttribute('content', value);

export function App() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const { title, description } = pageMeta[pathname.replace(/\/$/, '') || '/'] ?? notFoundMeta;
    document.title = title;
    setMeta('meta[name="description"]', description);
    setMeta('meta[property="og:title"]', title);
    setMeta('meta[property="og:description"]', description);
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', canonicalUrl(pathname));
  }, [pathname]);

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: pathname,
      title: document.title,
    });
  }, [pathname]);

  // Scroll to top on navigation, or to the hash target once the lazy route has rendered it
  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }
    let frame;
    let tries = 0;
    const seek = () => {
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (target) target.scrollIntoView({ block: 'start' });
      else if (tries++ < 60) frame = requestAnimationFrame(seek);
    };
    seek();
    return () => cancelAnimationFrame(frame);
  }, [pathname, hash]);

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <Header />
      <Main />
      <Footer />
      <ScrollToTop />
    </>
  );
}
